import styled from "styled-components";
import {BalanceLabelInnerDefaultBox} from "./balance-label-inner.default.box";

export const BalanceLabelInnerWSOPBox = styled(BalanceLabelInnerDefaultBox)`
    ${({theme}) => theme.font.presets.regular}
`;
